export class Constants {
    static DEFAULT_TAKE = 100;
    static DEFAULT_SKIP = 0;
    static NO_RESULT_FOUND = "No Result Found"
    static SUPPORT_MAIL_ADDRESS = "appsupport@rosendin.com";

    //Device
    static DEVICE_NAME = "deviceName";
    //static APPVERSION_SEARCH_FIELD_NAME = "appVersion";
    static USER_NAME = "userName";
    static DATE = "DATE";
    static DAY = "DAY";

    static PLEASE_SELECT_EMPLOYEE_EMAIL = "Please select employee email";
    static NOW = "now";
    static PROJECT_DEVICE_NAME = "projectDeviceName";
    static PROJECT_NAME = "projectName";
    static PROJECT_TASK_NAME = "projectTaskName";
    static USER_ID = "userId";
    static EMPLOYEEPAGE = "EmployeePage";
    static DEVICE_EMPLOYEE_NAME_AND_NUMBER = "deviceEmployeeNameAndNumber";
    static DEVICE_PROJECT_NUMBER = "deviceprojectNumber";
    static DEVICE_NAME = "deviceName";
    static ALLOW_ATTESTATION = "allowAttestation";
    static DEVICE_EMPLOYEE_NAME = "deviceEmployeeName";
    static DEVICE_PROJECT_NAME = "deviceProjectName";
    static INVALIDUSERNAMEORPASSWORD = "Invalid User Name or Password";
    static LOGGEDINSUCCESSFULLY = "Logged In Successfully";
    static ISSUE_NOTES = "issueNotes";
    static TIMECARD_EMPLOYEE_SEARCH = "timecardEmployeeNameAndNumber";
    static TIMECARD_DEVICE_SEARCH = "timecardDeviceName";
    static TIMECARD_PROJECT_SEARCH = "timeCardProject";
    static TIMECARD_TASKNAME_SEARCH = "timeCardTaskName";
    static TIMECARD_PAYCODE_SEARCH = "timeCardPayCode";
    static TIMECARD_TOTAL_HOURS_SEARCH = "timeCardTotalHours";
    static TIMECARD_ACTUAL_UNITS_SEARCH = "timeCardActualUnit";
    static TIMECARD_JOB_OVERRIDE_SEARCH = "timeCardJobOverride";
    static TIMECARD_WORK_DONE_AT_JOB_SITE_SEARCH = "timeCardWorkDoneAtJobSite";
    static TIMECARD_EXPECTATION_UNITS_SEARCH = "timeCardExpectationUnits";
    static WEEK_ENDING_DATE_SEARCH = "weekEndingDate";
    static TIMECARD_UNION_OVERRIDE_SEARCH = "timeCardUnionOverride";
    static TIMECARD_START_TIME_SEARCH = "timeCardStartTime";
    static TIMECARD_END_TIME_SEARCH = "timeCardEndTime";
    static TIMECARD_DAY_SEARCH = "timeCardDay";
    static TIMECARD_SYNC_DATE_SEARCH = "timeCardSyncedDateTime";
    static SECURITY_USERNAME_SEARCH = "securityUserName";
    static SECURITY_EMPLOYEE_NAME_SEARCH = "securityEmployeeName";
    static SECURITY_EMPLOYEE_NUMBER_SEARCH = "securityEmployeeNumber";
    static SECURITY_GROUP_NAME_SEARCH = "securityGroupName";
    static DIVISION_NAME_SEARCH = "divisionName";
    static JOBTITLE_NAME_SEARCH = "jobTitle";
    static JOBVALUE_SEARCH = "jobValue";
    static DIVISION_STATUS_SEARCH = "divisionStatus";
    static COPY_DEVICE_EMPLOYEE = "copyDeviceEmployee";
    static COPY_DEVICE_PROJECT = "copyDeviceProject";
    static PAYROLLNOTEOPTION_NAME_SEARCH = "payRollName";
    static STATUS_CODE_SEARCH_TEXT = "statusCodeSearchText";
    static TIMECARD_SEARCH_CODE_SEARCH = "searchStatusCode";
    static EQUIPMENT_LIST_SEARCH = "equipmentListSearch"
    static MATERIAL_LIST_SEARCH = "materialListSearch"

    static DATE_RAGE_VALIDATION = "The specified date range has an ending date that is earlier than the start date!.";
    static CURRENT_WEEK_DETAILS = "Showing current week details";
    static SELCET_FROM_DATE = "Please select from date";
    static SELCET_TO_DATE = "Please select to date";
    //Employee status
    static EMP_STATUS_ACTIVE = "active";
    static STATUS_INACTIVE = "inactive";
    static EMP_STATUS_ACTIVE_TEXT = "Active";
    static EMP_STATUS_INACTIVE_TEXT = "InActive";
    static OBJECT = "object";
    static SEARCH_PLACEHOLDER = "Search";
    static SEARCH_DEVICE_PLACEHOLDER = "Search by Device Name,Project Number & Name";
    static EMPLOYEE_NAME = "employeeName";
    static PROJECT_STATUS_ACTIVE = "active";
    static PROJECT_NUMBER = "projectNumber";

    static DAILY_DETAILS_SEARCH = "dailyDetailsSearch";
    static DAILY_DETAILS_INSPECTION = "dailyDetailsInspection";
    static DAILY_DETAILS_EQUIPMENT = "dailyDetailsEquipment";
    //TMvoucher
    static TM_VOUCHER_EMPOYLEE_SEARCH = "tmVoucherEmployee";
    static TM_VOUCHER_DEVICENAME_SEARCH = "tmVoucherDeviceName";
    static TM_VOUCHER_TIMECARD_DATE_SEARCH = "tmVoucherTimecardDate";
    static TM_VOUCHER_PROJECT_SEARCH = "tmVoucherProject";
    static TM_VOUCHER_TASKCODE_SEARCH = "tmVoucherTaskCode";
    static TM_VOUCHER_SYNCED_DATE_SEARCH = "tmVoucherSynedDate";
    static TM_VOUCHER_VERSION_SEARCH = "tmVoucherVersion";
    static TM_VOUCHER_STATUS_SEARCH = "tmVoucherStatus";
    static TM_VOUCHER_NUMBER_SEARCH = "voucherNumber";
    static DEVICEID = "deviceId";
    static PROJECTID = "ProjectId";
    static TASKCODEID = "TaskCodeID";
    static CREATEDDATE = "CreatedDate";

    //Employee
    static PLEASE_ENTER_EMPLOYEE_NUMBER = "Please enter Employee Number";
    static PLEASE_ENTER_EMPLOYEE_STATUS = "Please enter Employee Status";
    static PLEASE_ENTER_EMPLOYEE_TITLE = "Please enter Employee Title";
    static PLEASE_ENTER_EMPLOYEE_EMAIL = "Please enter Employee Email Address";
    static PLEASE_ENTER_HIRE_DATE = "Please enter Employee Hire Date";
    static PLEASE_ENTER_DIVISION = "Please enter Division Number";
    static PLEASE_ENTER_UNION_NUMBER = "Please enter Union Number";
    static PLEASE_ENTER_PROJECT_NUMBER = "Please enter Project Number";

    //Security
    static PLEASE_ENTER_EMPLOYEE_ID = "Please enter Employee Id";
    static PLEASE_ENTER_EMPLOYEE_NAME = "Please enter Employee Name";
    static PLEASE_SELECT_GROUP_ACCESS = "Please select Group Access";
    static PLEASE_SELECT_PROJECT_LEVEL_ACCESS = "Please select Project Level Access";
    static PLEASE_SELECT_DEVICE_ACCESS_BY_GROUPS = "Please select Device Access By Groups";
    static PLEASE_ENTER_USER_NAME = "Please enter User Name";
    static PLEASE_ENTER_PASSWORD = "Please enter Password";
    static PLEASE_ENTER_CONFIRM_PASSWORD = "Please enter Confirm Password";
    static PASSWORD_NOT_MATCHED = "Password not matched";
    static UPDATED_SUCCESSFULLY = "Updated successfully";
    static ENTER_VALID_USERNAME = "Please enter valid user name";
    static ENTER_VALID_PASSWORD = "Please enter password";
    //static PASSWORD_MIN_LENGTH = "Password and confirm password must be atleast 8 characters long";
    //static PASSWORD_MAX_LENGTH = "Password and confirm password length cannot be greater than 15 characters";
    static ALL_PROJECT_INVALID_OPTION = "Selected Project is invalid, as you have already chosen 'All Projects' as an option.";
    static ALL_DIVISION_INVALID_OPTION = "The chosen project level access value is invalid, as you have already chosen 'All divisions' as an option.";
    static ALL_DIVISION_DEVICE_ACCESS_BY_GROUPS_INVALID_OPTION = "The chosen device access by groups value is invalid, as you have already chosen 'All divisions' as an option.";
    static ENTER_VALID_EMAIL = "Please enter valid email";
    static PLEASE_ENTER_VALID_START_DATE = "Please enter valid Start Date";
    static PLEASE_ENTER_VALID_END_DATE = "Please enter valid End Date";

    //JobTitle
    static PLEASE_ENTER_JOBTITLE_RECORDS = "Please Enter All Job Records";
    static PLEASE_ENTER_VALID_DATA = "Please Enter the Valid Data";
    static IS_INCUDE_SYNC_CONFIRM = "Is Include Sync Value is Set";

    //Division
    static PLEASE_ENTER_DIVISION_NAME = "Please enter Division Number";
    static DIVISION_NAME_ALREADY_EXISTS = "Division number already exists";
    static ADMIN_ROLE_NAME = 'Administrator';
    static SYSTEM_ADMIN_ROLE_NAME = 'SystemAdmin';

    //PayRollNoteOption
    static PLEASE_ENTER_PAYROLLOPTION_NAME = "Please enter payroll note";

    //StatusCodeList
    static PLEASE_ENTER_STATUS_CODE = "Please enter the valid status code";

    // Equipment List
    static PLEASE_ENTER_EQUIPMENT_NAME = "Please enter equipment name";

    // Material List
    static PLEASE_ENTER_MATERIAL_NAME = "Please enter material name";

    //Forecast Interface Module
    static PLEASE_ENTER_FORECAST_DATE = "Please enter forecast date";
    static PLEASE_ENTER_FORECAST_DAYS = "Please enter forecast days";
    static FORECAST_DATE_ALREADY_EXISTS = "Forecast date already exists";

    //#region Alert message types
    static SUCCESS = "success";
    static INFO = "info";
    static WARNING = "warning";
    static WARN = "warn";
    static LOADING = "loading";
    static ERROR = "error";

    static DATA_BASE64 = "data:image/png;base64,";

    static PDFDATA_BASE64 = "data:application/pdf;base64,";

    static PAGE_CLAIMS = {
        SECURITY_PAGE: "pg.scrty",
        PROJECT_PAGE: "pg.prjt",
        EMPLOYEE_PAGE: "pg.emp",
        TIMECARD_PAGE: "pg.tmecrd",
        DEVICE_PAGE: "pg.dvce",
        REPORT_PAGE: "pg.rprt",
        DIVISION_PAGE: "pg.dvs",
        FORECAST_PAGE: "pg.fore",
        STATUSCODELIST_PAGE: "pg.scdlt",
        PAYROLLNOTEOPTION_PAGE: "pg.prno",
        EQUIPMENTLIST_PAGE: "pg.eqmtlt",
        TMVOUCHER_PAGE: "pg.tmvochr",
        MATERIALLIST_PAGE: "pg.matelt",
        SUPERVISOROVERRIDEREASONLIST_PAGE: "pg.spvrorern"
    };

    static MENU_CLAIMS = {
        SECURITY_MENU: "mn.scrty",
        PROJECT_MENU: "mn.prjt",
        EMPLOYEE_MENU: "mn.emp",
        TIMECARD_MENU: "mn.tmecrd",
        DEVICE_MENU: "mn.dvce",
        REPORT_MENU: "mn.rprt",
        DIVISION_MENU: "mn.dvs",
        //JOBTITLE_MENU: "mn.jobtit",
        FORECAST_MENU: "mn.fore",
        PAYROLLNOTEOPTION_MENU: "mn.prno",
        STATUSCODELIST_MENU: "mn.scdlt",
        EQUIPMENTLIST_MENU: "mn.eqmtlt",
        TMVOUCHER_MENU: "mn.tmvochr",
        MATERIALLIST_MENU: "mn.matelt",
        SUPERVISOROVERRIDEREASONLIST_MENU: "mn.spvrorern"
    }

    static BUTTON_CLAIMS = {
        PROJECT_EDIT_BUTTON: "prjtedtbtn",
        EMPLOYEE_EDIT_BUTTON: "empedtbtn",
        DEVICE_EDIT_BUTTON: "dvcedtbtn",
        REPORT_ADD_BUTTON: "addrptbtn",
        REPORT_EDIT_BUTTON: "rptedtbtn",
        REPORT_DELETE_BUTTON: "rptdltbtn",
        PROJECT_STATUS_EDIT_BUTTON: "prjtstasedtbtn",
        EMPLOYEE_STATUS_EDIT_BUTTON: "empstasedtbtn",
        DEVICE_STATUS_EDIT_BUTTON: "dvsstasedtbtn",
        EMPLOYEE_ADD_BUTTON: "addempbtn",
        USER_ACTIVATE_DEACTIVATE_BUTTON: "usractvordacvbtn",
        DEVICE_ATTESTATION_EDIT_BUTTON: "dvsattonedtbtn",
    }

    static AUTHORIZATION = 'Authorization';
    static BEARER = 'Bearer';
    static SPACE = " ";

    //Group Access
    static READ_ONLY = "Read Only";
    static CONTRIBUTE = "Contribute";
    static SYSTEM_ADMIN = "SystemAdmin";
    static PROJECT_MANAGER = "Project Manager";

    //Email Validation
    static PLEASE_ENTER_VALID_EMAIL = "Please enter valid email";
    static ENTER_EMAIL_ALREADY_SELECTED = "Entered email already selected";

    static RUN_DAILY = "daily";
    static RUN_MONTHLY = "monthly";
    static RUN_WEEKLY = "weekly";

    static TIMECARD_LUNCH_START_TIME_SEARCH = "timeCardLunchStartTime";
    static TIMECARD_LUNCH_END_TIME_SEARCH = "timeCardLunchEndTime";

    static APPROVED_ATTESTATION_TEXT = "I certify that I have carefully reviewed my timecard and it accurately reflects all of the hours that I worked today. I further certify that I was given the opportunity to take all meal and rest breaks in accordance with company policies and applicable law.";
    static REJECTION_A_TEXT = "I was not provided meal break(s) in accordance with company policies and applicable law.";
    static REJECTION_B_TEXT = "I was not provided rest break(s) in accordance with company policies and applicable law.";
    static REJECTION_C_TEXT = "My timecard does not accurately reflect all of the hours that I worked today.";

    static APPROVED_ATTESTATION_SPANISH_TEXT = "Certifico que he revisado con cuidado mi tarjeta de horas y reflecta con precisión todas las horas que trabajé hoy. Certifico además que se me dio la oportunidad de tomar todos los descansos para comer y descansar de acuerdo con las pólizas de la empresa y la ley aplicable.";
    static REJECTION_A_SPANISH_TEXT = "No me proporcionaron descansos para comer de acuerdo con las pólizas de la empresa y la ley aplicable.";
    static REJECTION_B_SPANISH_TEXT = "No me proporcionaron descansos de acuerdo con las pólizas de la empresa y la ley aplicable.";
    static REJECTION_C_SPANISH_TEXT = "Mi tarjeta de horas no reflecta con precisión todas las horas que trabajé hoy.";

    static SUPERVISOR_OVERRIDE_TEXT = "Supervisor override because employee is not available.";
    static ATTESTATION_STATUS_SEARCH = "attestationStatusSearch";

    static SUPERVISOR_OVERRIDE_REASON_NAME_SEARCH = "SupervisorOverrideReasonSearch";

    static PLEASE_ENTER_SUPERVISOR_OVERRIDE_REASON = "Please enter Supervisor Override Reason";

    static ATTESTATION_STATUS_OVERRIDE = "Override";
    static ATTESTATION_STATUS_APPROVED = "Approved";
    static ATTESTATION_STATUS_REJECTED = "Rejected";
    static ATTESTATION_NONE = "None";

    static ATTESTATION_LANGUAGE_ENGLISH = "English";
    static ATTESTATION_LANGUAGE_SPANISH = "Spanish";
    static ATTESTATION_YES = "Y";
    static ATTESTATION_NO = "N";

    static YES_TEXT = "Yes";
    static NO_TEXT = "No";
    static SPANISH_YES_TEXT = "Sí";

    static OTHER = "Other";
    static PNG_BASE64 = "data:image/png;base64,";

    static ATTESTATION_STATUS_OVERRIDE_SEARCH_TEXT = "Override";
    static ATTESTATION_STATUS_APPROVED_SEARCH_TEXT = "Approve";
    static ATTESTATION_STATUS_REJECTED_SEARCH_TEXT = "Reject";

    static ALL_PROJECTS = "AllProjects";

    static TM_VOUCHER_SIGNATURE_SEARCH = "TimecardSignatureSearch";
    static TM_VOUCHER_SIGNATURE_YES = "Yes";
    static TM_VOUCHER_SIGNATURE_NO = "No";
    static ALLOW_TM_VOUCHER_SIGNATURE = "AllowTMVoucherSignature";
    static PROCESSED_STATUS = "Processed";
    static EXPORTED_STATUS = "Exported";
    static NEW_STATUS = "New";

    static SAVED_SUCCESSFULLY = "Saved successfully";
    static ASSIGN_EMP = "ASSIGN_EMP";
    static UNASSIGN_EMP = "UNASSIGN_EMP";
    static ASSIGN_PRO = "ASSIGN_PRO";
    static UNASSIGN_PRO = "UNASSIGN_PRO";
    static ASSIGN_DEVICE = "ASSIGN_DEVICE";
    static UNASSIGN_DEVICE = "UNASSIGN_DEVICE";
    static COPY_DEVICE_EMP_SCROLL = "COPY_DEVICE_EMP_SCROLL";
    static COPY_DEVICE_PRO_SCROLL = "COPY_DEVICE_PRO_SCROLL";
    static MAIN_EMPLOYEE_SECTION_SCROLL = "MAIN_EMPLOYEE_SECTION_SCROLL";
    static MODAL_EMPLOYEE_SECTION_SCROLL = "MODAL_EMPLOYEE_SECTION_SCROLL";
    static DEVICE_EMPLOYEE_SECTION_SCROLL = "DEVICE_EMPLOYEE_SECTION_SCROLL";
    static DEVICE_PROJECT_SECTION_SCROLL = "DEVICE_PROJECT_SECTION_SCROLL";

    //Division Name Length Validation
    static DIVISION_NAME_MAX_LENGTH = 100;
}